


































































import Vue from "vue";
import iwTabsLanguageSwitcher from "@/encoding/components/buildingBlocks/tabsLanguageSwitcher/TabsLanguageSwitcher.vue";
import iwAiDescriptionPanel from "@/shared/components/AiDescriptionPanel.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import "@/assets/sass/optimizedEncoding/optimizedEncoding.scss";
import { v4 as uuidv4 } from "uuid";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { hasOverLongTitle } from "@/shared/scripts/helpers/titleValidation";
import { Trans } from "@/shared/scripts/helpers/translation/translation";
import { mapGetters, mapActions, mapState } from "vuex";

export default Vue.extend({
    components: {
        iwTabsLanguageSwitcher: iwTabsLanguageSwitcher,
        iwAiDescriptionPanel: iwAiDescriptionPanel,
        iwTooltip: iwTooltip,
        iwNextPreviousButton: iwNextPreviousButton
    },
    data: function() {
        return {
            inputName: "title-description",
            specificId: uuidv4() as string,
            isButtonDisabled: false as boolean,
            activeTabLanguage: "en" as string,
            liveDescriptionContent: {} as Record<string, string>
        };
    },
    computed: {
        ...mapState("FormModule", ["isEditionMode"]),
        ...mapGetters({
            isLogged: "UserModule/isLogged",
            shouldDisplayError: "StepsWizard/shouldDisplayError",
        }),
        // Title errors are rendered against the title input itself by the tabs component.
        getErrorMessage: function(): string {
            return (!this.shouldDisplayError && (this.$store.getters["FormModule/getErrorObjectByPath"]("property.description.en") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("property.description.nl") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("property.description.fr") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("property.description"))) ?? "";
        },
        hasTitleLengthError: function(): boolean {
            return hasOverLongTitle(this.$store.getters["FormModule/getValue"]("property.title"));
        },
        languages: function(): Array<Record<string, unknown>> {
            return [
                {
                    "language": this.$t("english_language"),
                    "prefix": "en",
                    "validate": false,
                },
                {
                    "language": this.$t("french_language"),
                    "prefix": "fr",
                    "validate": false,
                },
                {
                    "language": this.$t("dutch_language"),
                    "prefix": "nl",
                    "validate": false
                }
            ];
        },
        validatedSteps: function(): string[] {
            return this.$store.getters["StepsWizard/getValidatedSteps"];
        },
        descriptionPhrases: function(): string[] {
            const text = this.$t("add_title_and_description_by_language") as string;
            return text.split(/\\n/) as string[];
        },
    },

    created: function() {
        this.activeTabLanguage = Trans.currentLocale;
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_step10_display_info");
    },

    methods: {
        ...mapActions({
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next"
        }),
        handleTabLanguageChange: function(language: string) {
            this.activeTabLanguage = language;
        },
        handleDescriptionLiveUpdate: function(payload: { locale: string; value: string }) {
            this.$set(this.liveDescriptionContent, payload.locale, payload.value);
        },
        clickNext: function(){
            if (this.isEditionMode){
                this.isButtonDisabled = true;
                validationClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            } else {
                this.isButtonDisabled = true;
                updateClassified(() => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();

                    });
                });
            }
        },
        clickPrevious: function(){
            this.goToPreviousStep();
        }
    }
});
